module.exports = __webpack_public_path__ + "static/media/aug2021.d08ef381.svg";